<template>
    <div>
        <div class="ui huge menu">
            <a href="#" class="item" @click.prevent="triggerMenu">
                <i class="content icon"></i>
            </a>
        </div>
        <div class="ui container">
            <div class="ui centered grid">
                <div class="ui ten wide column">
                    <div class="ui segment">
                        <table class="ui very basic striped table">
                            <tr>
                                <td>Admin overrides current user selection</td>
                                <td class="right aligned four wide">
                                    <div class="ui checkbox">
                                        <input type="checkbox" id="adminOverridesSelected" v-model="settings.adminOverridesSelected" @change="trackChange">
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Booking session timeout warning shows after</td>
                                <td class="four wide">
                                    <div class="ui right labeled input" style="width: 100px">
                                        <input type="text" v-model="settings.sessionTimeout" placeholder="Enter time">
                                        <div class="ui basic label">
                                            min
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Upon warning, booking gets cleared after</td>
                                <td class="four wide">
                                    <div class="ui right labeled input" style="width: 100px">
                                        <input type="text" v-model="settings.sessionTimeoutClear" placeholder="Enter time">
                                        <div class="ui basic label">
                                            min
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>How many minutes before can booking be made?</td>
                                <td class="four wide">
                                    <div class="ui right labeled input" style="width: 100px">
                                        <input type="text" v-model="settings.bookingAllowedBefore" placeholder="Enter time">
                                        <div class="ui basic label">
                                            min
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                        <button class="ui primary button" @click="saveSettings"><i class="checkmark icon"></i> Save settings</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import * as services from './../../services/'

    export default {
        data() {
            return {
                'settings': {
                    'adminOverridesSelected': false,
                    'sessionTimeout': null,
                    'sessionTimeoutClear': null,
                    'bookingAllowedBefore': null,
                    'reasonsForBooking': []
                },
                'newReason': null,
            }
        },
        mounted() {
            $('.ui.checkbox').checkbox()

            services.settingService.find({
                $limit: 1,
                $sort: {
                    _id: -1
                },
                query: {
                  'toMinutes': true
                }
            }).then(settings => {
                if (settings.total > 0) this.settings = settings.data[0]
            })
        },
        methods: {
            triggerMenu() {
                $('.ui.sidebar').sidebar('toggle')
            },
            saveSettings() {
              if (!this.settings._id) {
                services.settingService.create(this.settings).then((setting) => {
                  toastr.success('Settings updated')
                })
              } else {
                services.settingService.patch(this.settings._id, this.settings).then((setting) => {
                  toastr.success('Settings updated')
                })
              }
            },
            trackChange(value) {
              this.settings.adminOverridesSelected = $(value.target).prop('checked')
            },
            saveReason() {
              if (!this.settings.reasonsForBooking) this.settings.reasonsForBooking = []
              this.settings.reasonsForBooking.push(this.newReason)
              this.newReason = null
            }
        },
        components: {
        }
    }
</script>

<style scoped>
    .pull.right {
        float: right;
    }
    .settings-value {
        width: 120px;
    }
</style>



// WEBPACK FOOTER //
// Settings.vue?a3243d0a